import { ReactNode } from 'react';
import { Logo } from '~/components/logo';

type Props = {
  children: ReactNode;
};

export const SelfServiceAuthLayout = ({ children }: Props) => {
  return (
    <main className="min-h-screen bg-white lg:grid lg:grid-cols-[minmax(0,min(33.333333%,480px))_1fr]">
      <aside className="relative hidden min-h-screen flex-col items-center justify-center overflow-hidden bg-[linear-gradient(163.46deg,#6805E5_-10.04%,#8733FE_115.8%)] px-[72px] text-white lg:flex">
        <div className="absolute left-8 top-[30px]">
          <Logo variant="light" />
        </div>
        <div
          aria-hidden
          className="absolute inset-0 bg-[url('/img/background.png')] bg-contain bg-right-bottom bg-no-repeat"
        />
        <div className="relative w-full">
          <h2 className="mb-8 font-heading text-4xl font-semibold leading-[1.4]">
            The Next Step in Online Fundraising
          </h2>
          <p className="text-base font-normal leading-[1.8]">
            Kindest brings modern marketing methods to the online fundraising world with simple and
            easy to use tools.
          </p>
        </div>
      </aside>

      <section className="relative flex min-h-screen items-center justify-center px-5 py-24 sm:px-10">
        <div className="absolute left-5 top-8 lg:hidden">
          <Logo variant="dark" />
        </div>
        <div className="w-full max-w-md">{children}</div>
      </section>
    </main>
  );
};
